import React from 'react';
import spinner from './spinner.svg';

function Spinner() {
    return <img src={spinner} alt="Spinner" className="spinner" />;
}

export default Spinner;
